import httpUtils from '../utils/HttpUtils'
import session from '../utils/Session'

class BaseService {
  constructor () {
    this.__init()
  }

  __init () {
  }

  /**
   * 上传图片，返回图片完成url
   */
  async uploadImage (file) {
    let result = null;
    try {
      result = await httpUtils.upload('/oss/upload', {file});
      console.info(result)
    } catch (error) {
      throw new Error(error)
    }
    return result.data;
  }
  async downImage ({mediaId}) {
    let result = null;
    try {
      result = await httpUtils.post('/oss/lightDownload', {mediaId});
      console.info(result)
    } catch (error) {
      throw new Error(error)
    }
    return result;
  }
  /**
   * 微信小程序选择上传图片
   */
  uploadImageWxMini () {
    return new Promise(function (resolve, reject) {
      wx.chooseImage({
        count: 1,
        success: (res) =>{
          console.log('选择凭证', JSON.stringify(res));
          var localIds = res.localIds;
          // Indicator.open({
          //   text: '加载中...',
          //   spinnerType: 'fading-circle'
          // });
          wx.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (data) {
              console.log('选择凭证', JSON.stringify(data));
              var serverId = data.serverId; // 返回图片的服务器端ID
              console.log('选择凭证', serverId);
              resolve(serverId);
            },
            fail: (err)=>{
              reject(err);
            }
          });
        },
        fail: (err)=>{
          reject(err);
        }
      });
    });
  }
}
export default new BaseService()
